(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* The ticker's speed is a distance per second, not a fixed loop time, so
       a long message and a short one pass at the same pace. Measured once the
       fonts have settled, because the data face changes the width. */
    const initTicker = (bar) => {
      if (bar.dataset.tickerBound) return;
      bar.dataset.tickerBound = 'true';

      const group = bar.querySelector('.announcement__group');
      const speed = Number(bar.dataset.tickerSpeed) || 32;
      const measure = () => {
        const width = group?.getBoundingClientRect().width;
        if (width) bar.style.setProperty('--ticker-duration', `${(width / speed).toFixed(1)}s`);
      };
      measure();
      document.fonts?.ready.then(measure);

      const button = bar.querySelector('[data-announcement-pause]');
      button?.addEventListener('click', () => {
        const paused = !bar.hasAttribute('data-paused');
        bar.toggleAttribute('data-paused', paused);
        button.setAttribute('aria-pressed', String(paused));
      });
    };

    const initRotate = (bar) => {
      if (bar.dataset.rotateBound) return;
      bar.dataset.rotateBound = 'true';

      const list = bar.querySelector('.announcement__slides');
      const items = Array.from(bar.querySelectorAll('.announcement__slides [data-announcement]'));
      if (items.length < 2) return;

      let index = Math.max(
        0,
        items.findIndex((item) => item.classList.contains('is-active')),
      );
      let timer = null;
      const speed = (Number(bar.dataset.rotateSpeed) || 5) * 1000;

      const show = (next) => {
        const leaving = items[index];
        leaving.classList.remove('is-active');
        leaving.classList.add('is-leaving');
        window.setTimeout(() => leaving.classList.remove('is-leaving'), 500);
        index = (next + items.length) % items.length;
        items[index].classList.remove('is-leaving');
        items[index].classList.add('is-active');
      };

      const allowAuto = () =>
        bar.dataset.autoRotate === 'true' && !reduced.matches && window.RadRocks && window.RadRocks.animations;

      const stop = () => {
        clearInterval(timer);
        timer = null;
      };
      const start = () => {
        stop();
        if (allowAuto()) timer = setInterval(() => show(index + 1), speed);
      };

      /* Pause while the pointer or focus is on the bar, and in hidden tabs. */
      bar.addEventListener('pointerenter', stop);
      bar.addEventListener('pointerleave', start);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));

      /* Automatic changes are not announced -- a message every few seconds
         would talk over everything else on the page. One the visitor asked
         for is. */
      const step = (delta) => {
        list.setAttribute('aria-live', 'polite');
        show(index + delta);
      };
      bar.querySelector('[data-announcement-prev]')?.addEventListener('click', () => step(-1));
      bar.querySelector('[data-announcement-next]')?.addEventListener('click', () => step(1));

      start();
    };

    const scan = (root) => {
      root.querySelectorAll('[data-announcement-ticker]').forEach(initTicker);
      root.querySelectorAll('[data-announcement-rotate]').forEach(initRotate);
    };
    scan(document);
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  // Un-stick the photograph column when it is taller than the viewport: a
  // stuck column you cannot scroll to the bottom of hides its own last image.
  //
  // A section's javascript tag is concatenated into the theme-wide scripts.js
  // and therefore runs on every page, so this must never observe the whole
  // document -- a subtree MutationObserver here would re-scan on every
  // predictive-search keystroke and every facet swap, storewide. Panels are
  // re-created by Section Rendering swaps, which announce themselves with
  // shopify:section:load, so that one event is all the re-scanning needed.
  const seen = new WeakSet();

  const measure = (panel) => {
    panel.classList.toggle('is-overlong', panel.offsetHeight + 48 > window.innerHeight);
  };

  const init = (panel) => {
    if (seen.has(panel)) return;
    seen.add(panel);
    // A variant change swaps the whole section, panel included. The observer
    // also watches the document, so without this every swap left one more
    // observer measuring a detached panel on each resize, for good.
    const observer = new ResizeObserver(() => {
      if (!panel.isConnected) return observer.disconnect();
      measure(panel);
    });
    observer.observe(panel);
    observer.observe(document.documentElement);
    measure(panel);
  };

  const scan = (root) => (root || document).querySelectorAll('[data-sticky-panel]').forEach(init);

  scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));

  } catch(e) { console.error(e); }
})();
})();
